import { type FinancialAccountBankingDetailsConstructor } from '../../entities/FinancialAccountBankingDetails/FinancialAccountBankingDetails'
import { type FinancialAccountBankingDetailsApiModel } from '../api-models/FinancialAccountBankingDetailsApiModel'

export const mapFinancialAccountBankingDetailsApiModel = (
  data: FinancialAccountBankingDetailsApiModel
): FinancialAccountBankingDetailsConstructor => ({
  name: data.account_name,
  accountNumber: data.account_number,
  routingNumber: data.routing_number,
  institutionNumber: data.institution_number,
  transitNumber: data.transit_number,
  sortCode: data.sort_code,
})
